import * as React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import SidebarMenu from "./SidebarMenu";
import FutureFuc from "../tmp/FutureFuc";
import { WeatherPaper } from 'pages/components/WeatherPaper';
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import "../css/lnb.css";
import { SwItsGetOperationRouteProvider, SwItsFutureRouteGridInfo, SwItsFutureRouteCctvInfo } from 'pages/components/dashboard/SwItsGetOperationRoute';
import { FutureFucDash } from "../tmp/FutureFuc";

import { useTranslation } from 'react-i18next';
export default function FutureTransportationViewD() {
    React.useEffect(() => { }, []);

    const { t, i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ko' ? 'en' : 'ko';
        i18n.changeLanguage(newLang);
    };

    return (
        <Box sx={{ height: "100%", width: "100%" }}>
            <div className="dashboard container flx a_center">
                <SidebarMenu />
                <div className="ctrlMain">
                    <div className="mainTit flx j_spc_btw a_center">
                        <div className="titBox">
                            <p
                                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                                onClick={toggleLanguage}
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                            >
                                {t('subtitle')}
                            </p>
                            <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                                {t('mainTitle6')}
                            </p>
                        </div>
                        <div className="weatherWrap flx a_center j_spc_btw">
                            <WeatherPaper />
                        </div>
                    </div>
                    <div className="mainInfo ftvInfo">
                        {/*메인박스*/}
                        <div className="inner">
                            <div className="titWrap flx j_spc_btw">
                                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-08)' }}>{t('LocationOfAVOnTheRoute')}
                                </h2>
                            </div>
                            <div className="boxCont ftvCont L_lr">
                                <SwItsGetOperationRouteProvider>
                                    <div className="ftvCont_left flx flx_col">
                                        <SwItsFutureRouteGridInfo />
                                        <div className="cctvWrap flx flx_col">
                                            <SwItsFutureRouteCctvInfo cameraCount={2} startIndex={1} />
                                        </div>
                                    </div>
                                    <div className="ftvMap">
                                        {/* 지도영역  */}
                                        <div
                                            className="mapBox"
                                            style={{ width: "100%", height: "100%" }}>
                                            <FutureFucDash />
                                        </div>
                                        {/* <img src="/images/dashboard/Ft_img.svg" alt="미래교통지도영역"></img> */}
                                    </div>
                                    <div className="ftvCont_right flx flx_col">
                                        <div className="cctvWrap flx flx_col">
                                            <SwItsFutureRouteCctvInfo cameraCount={3} startIndex={3} />
                                        </div>
                                    </div>
                                </SwItsGetOperationRouteProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    );
}
